import { render, staticRenderFns } from "./IncomingCallModal.vue?vue&type=template&id=ee80bcd4&scoped=true"
import script from "./IncomingCallModal.vue?vue&type=script&lang=ts"
export * from "./IncomingCallModal.vue?vue&type=script&lang=ts"
import style0 from "./IncomingCallModal.vue?vue&type=style&index=0&id=ee80bcd4&css=true&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.9_css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_p_rtqrtxx4ab5lun7j52al72xaei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee80bcd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee80bcd4')) {
      api.createRecord('ee80bcd4', component.options)
    } else {
      api.reload('ee80bcd4', component.options)
    }
    module.hot.accept("./IncomingCallModal.vue?vue&type=template&id=ee80bcd4&scoped=true", function () {
      api.rerender('ee80bcd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/twilio/IncomingCallModal.vue"
export default component.exports